import React, { useEffect, useRef, useState } from 'react'
import { Table, message, Image, Upload } from 'antd'
import { ColumnsType } from 'antd/es/table'
import useGlobalModel from '@/model/globalModel'
import { YHModal } from '@/components/YHModal'
import { EditableRow, EditableCell } from '@/components/YHEditTable/editTable'
import { CloseOutlined, PlusCircleOutlined } from '@ant-design/icons'
import { baseModel } from '../model'
import { globalPrompt } from '@/components/message'
import { service } from '../service'
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseUploadData } from '@/utils/constants'
import { UploadChangeParam, UploadFile } from 'antd/lib/upload/interface'

export const AddModal = () => {
    const [dataSource, setDataSource] = useState<any>([])
    const { addCarVisible, setAddCarVisible, loadData } = baseModel()
    const formRef = useRef<any>()
    const {
        user: { shopCode, createUser },
    } = useGlobalModel(({ user }) => [user])
    const [saveLoading, setSaveLoading] = useState<boolean>(false) //  保存按钮
    useEffect(() => {
        setDataSource([
            {
                temporaryId: new Date().getTime() + Math.floor(Math.random() * 10000),
                type: '管理员',
                createUserId: shopCode,
                createUser: createUser,
            },
        ])
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addCarVisible])
    useEffect(() => {
        formRef.current = dataSource
    }, [dataSource])
    const DeleteRow = (record: any) => {
        const data = formRef.current.filter((i: { temporaryId: any }) => record.temporaryId !== i.temporaryId)
        setDataSource(data)
    }
    const deleteImg = (value: any) => {
        try {
            handleSave({ ...value, fileList: [], md5: '', photo: '' })
            message.success('图片删除成功！')
        } catch (error) {
            message.error('图片删除失败！')
        }
    }
    const onPreview = async (file: UploadFile<any>, res: any) => {
        try {
            if (file.status === 'done') {
                if (file?.response?.retCode === 0) {
                    const data = {
                        name: file.name,
                        size: file.size,
                        type: file.type,
                        uid: file.response.retData,
                    }
                    handleSave({ ...res, fileList: [data], md5: data.uid, photo: data.name })
                    message.success('图片添加成功！')
                } else {
                    message.error('图片上传失败，请重新上传!')
                }
            }
        } catch (error) {
            message.error('图片添加失败！')
        }
    }
    const AddRow = (record: any) => {
        const dataIndex = formRef.current.findIndex((i: { temporaryId: any }) => record.temporaryId === i.temporaryId)
        const newData = dataSource
        newData.splice(dataIndex + 1, 0, {
            temporaryId: new Date().getTime() + Math.floor(Math.random() * 10000),
            type: '管理员',
            createUserId: shopCode,
            createUser: createUser,
        })
        setDataSource([...newData])
    }
    const columns = [
        {
            title: '操作',
            width: 140,
            fixed: 'left',
            align: 'center',
            render: (t: any, r: any) => (
                <>
                    {dataSource.length > 1 && (
                        <span
                            style={{
                                fontSize: '14px',
                                color: '#4165E3',
                                cursor: 'pointer',
                            }}
                            onClick={() => DeleteRow(r)}
                        >
                            删除
                        </span>
                    )}
                    <span
                        style={{
                            fontSize: '14px',
                            color: '#4165E3',
                            cursor: 'pointer',
                            marginLeft: '15px',
                        }}
                        onClick={() => AddRow(r)}
                    >
                        新增一行
                    </span>
                </>
            ),
        },
        {
            title: (
                <span>
                    姓名 <span style={{ color: 'red' }}> *</span>
                </span>
            ),
            width: 120,
            dataIndex: 'driverName',
            editable: true,
            align: 'center',
        },
        {
            title: (
                <span>
                    头像 <span style={{ color: 'red' }}> *</span>
                </span>
            ),
            width: 140,
            align: 'center',
            fixed: 'left',
            render: (_text: any, records: { md5: string }) =>
                records.md5 ? (
                    <>
                        <Image src={getBaseImgLookUrl(records.md5)} style={{ maxWidth: '100px', maxHeight: '120px' }} />
                        <CloseOutlined
                            onClick={() => deleteImg(records)}
                            style={{
                                color: 'red',
                                fontSize: '14px',
                                position: 'absolute',
                                right: '10px',
                                cursor: 'pointer',
                            }}
                        />
                    </>
                ) : (
                    <Upload
                        name="file"
                        action={getBaseImgUploadUrl()}
                        data={getBaseUploadData()}
                        onChange={(info: UploadChangeParam<UploadFile<any>>) => onPreview(info.file, records)}
                        showUploadList={false}
                        beforeUpload={(file: any) => {
                            let fileEnd: string = file.name.substring(file.name.lastIndexOf('.'))
                            let filetypes: string[] = ['.jpg', '.png', '.jpeg', 'svg', '.gif']
                            let isType = filetypes?.includes(fileEnd)
                            if (!isType) {
                                message.error('不支持该格式的上传,当前仅支持图片类型文件')
                            }
                            return isType
                        }}
                    >
                        {' '}
                        <PlusCircleOutlined style={{ color: 'blue', fontSize: '22px', cursor: 'pointer' }} />
                    </Upload>
                ),
        },
        {
            title: (
                <span>
                    账号 <span style={{ color: 'red' }}> *</span>
                </span>
            ),
            width: 120,
            dataIndex: 'phoneNumber',
            editable: true,
            align: 'center',
        },
    ]

    const newColumn = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: any, rowIndex: number) => ({
                colIndex: index + 1,
                rowIndex,
                record,
                rules: col.rules,
                options: col.options,
                editType: col.editType,
                editable: col?.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                mode: col.mode,
                handleSave: handleSave,
                onInputEnter: col.onInputEnter,
            }),
        }
    })
    //内联编辑
    const handleSave = (row: any) => {
        const newData = [...dataSource]
        const index = newData.findIndex((item) => row.temporaryId === item.temporaryId)
        const item = newData[index]
        newData.splice(index, 1, { ...item, ...row })
        setDataSource(newData)
    }

    const onOk = async () => {
        let errorList: any = []
        dataSource.forEach((item: { driverName: any; md5: any; phoneNumber: any; licensePlate: any }) => {
            if (item.driverName && item.md5 && item.phoneNumber) {
                return
            } else {
                errorList.push(item.licensePlate)
            }
        })
        if (errorList.length > 0) {
            return message.warning(`请补全${errorList}必填信息，再继续操作！`)
        }
        try {
            setSaveLoading(true)
            const submitData = dataSource.map((item: any) => ({
                ...item,
                dealerName: Array.isArray(item.dealerName) ? item.dealerName.join(',') : item.dealerName,
            }))
            let { retData } = await service.insert(submitData)
            setSaveLoading(false)
            setAddCarVisible(false)
            message.success(`添加成功！`)
            loadData()
            return retData
        } catch (error) {
            setSaveLoading(false)
        }
    }

    const onClose = () => {
        globalPrompt('modal', {
            title: '新增管理员',
            type: 'warning',
            text: '您还有正在新增的管理员记录...是否关闭？',
            okText: '关闭页面',
            onOk: () => setAddCarVisible(false),
            cancelText: '继续添加',
            onCancel: () => {
                return
            },
        })
    }

    return (
        <YHModal
            visible={addCarVisible}
            title="您正在添加管理员..."
            cancelText="取消添加"
            okText="确定添加"
            onCancel={onClose}
            onOk={onOk}
            width={'70%'}
            showFooter={true}
        >
            <Table
                loading={saveLoading}
                rowKey={(record) => record.temporaryId}
                columns={newColumn as ColumnsType<any>}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                dataSource={dataSource}
                scroll={{ x: 'max-content' }}
                pagination={false}
                bordered
            />
        </YHModal>
    )
}
